import { ReadContextRoleScopePickerRequestBaseDTO } from './read-context-role-scope-picker-request-base-dto';
import { TypeScopeDTO } from './type-scope-dto';

export interface ReadContextRoleScopePickerValidationRequestDTO extends ReadContextRoleScopePickerRequestBaseDTO {
    existingScope?: TypeScopeDTO[];
    additionalScope?: TypeScopeDTO[];
}
